var image_upload_default = {
  "container": "KrEJF",
  "disabled": "YKbc2",
  "imageInput": "sRjuP",
  "overlay": "ovuL-",
  "text": "m83zV",
  "shown": "fdsBI",
  "hide": "n-4MP",
  "spinner": "IGbQx",
  "spin": "e-4na"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
